import { useTranslation } from "react-i18next";

export const useServicesContent = () => {
  const { t } = useTranslation();

  return [
    {
      serviceName: t("home.services.0.title"),
      icon: "flaticon-worker",
    },
    {
      serviceName: t("home.services.1.title"),
      icon: "flaticon-factory-1",
    },
    {
      serviceName: t("home.services.2.title"),
      icon: "flaticon-settings",
    },
  ];
};

export const useHomeSliderContent4 = () => {
  const { t } = useTranslation();

  return [
    {
      image: require("../../images/main-slider/plastique.JPG"),
      title: t("home.slider.0.title"),
      description: t("home.slider.0.description"),
      link: "/plastics",
    },
    {
      image: require("../../images/main-slider/aerosol.JPG"),
      title: t("home.slider.1.title"),
      description: t("home.slider.1.description"),
      link: "/metallics",
    },
  ];
};
